import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { CoverCropCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface CoverCropCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const CoverCropCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: CoverCropCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="coverCrop"
      onSaveSuccess={onSaveSuccess}
    >
      <CoverCropCellDisplay value={value} />
    </TraitCellContainer>
  )
}
